import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const Loading = ({ customText }) => {
  const { text } = useSelector((state) => state.loading);
  const [loadingIndex, setLoadingIndex] = useState(0);

  useEffect(() => {
    if (loadingIndex + 1 < text?.length) {
      setTimeout(() => {
        setLoadingIndex((prevIndex) => prevIndex + 1);
      }, 8000); // 8 seconds delay
    }
    // return () => clearTimeout(timer);
  }, [loadingIndex, text]);

  return (
    <div className="center-container">
      {text.length > 0 ? (
        <>
          {text.map((content, index) => {
            return loadingIndex === index ? (
              <div>
                <div className="loading-svg">
                  <img src="/assets/images/loader.gif" />
                </div>
                <div key={index} className="custom-text-loading">
                  <p>{content}</p>
                  <div className="snippet" data-title="dot-pulse">
                    <div className="stage">
                      <div className="dot-pulse"></div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null;
          })}
        </>
      ) : !!customText ? (
        <div>
          <div className="loading-svg">
            <img src="/assets/images/loader.gif" />
          </div>
          <div className="custom-text-loading">
            <p>{customText}</p>
            <div className="snippet" data-title="dot-pulse">
              <div className="stage">
                <div className="dot-pulse"></div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <img src="/assets/images/loader.gif" />
      )}
      {/* <img src="/assets/images/loader.gif"  /> */}
    </div>
  );
};

export default Loading;
